function generateRadarChart(chartValue, id) {
  const options = {
    responsive: true,
    scales: {
      r: {
        beginAtZero: true,
        min: 0,
        max: 5,
        grid: {
          color: '#ddd',
        },
        angleLines: {
          color: '#bbb',
        },
        ticks: {
          stepSize: 1,
          backdropColor: '#f9f9f9',
          color: '#333',
        },
        pointLabels: {
          font: {
            size: 14,
            weight: 'bold',
          },
          color: '#333',
          callback: function (value, index) {
            return `${value} ${data.datasets[0].data[index]}`;
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
        labels: {
          color: '#333',
        },
      },
    },
  };

  const data = {
    labels: ['甘味', 'コク', '香り', '酸味', '苦味', '後味'],
    datasets: [
      {
        label: 'コーヒーの特徴',
        data: chartValue.map((v) => Number(v)), // ここに各パラメータの数値を入力
        backgroundColor: 'rgba(192, 162, 105, 0.8)', // 画像に基づいた色に変更
        borderColor: 'rgb(192, 162, 105, 1)', // 枠線の色も調整
        borderWidth: 2,
        pointBackgroundColor: 'rgba(192, 162, 105, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(192, 162, 105, 1)',
      },
    ],
  };

  const config = {
    type: 'radar',
    data,
    options,
  };

  // Render Chart
  const radarChart = new Chart(document.getElementById(id), config);
  radarChart.canvas.parentNode.style.width = '400px';
  radarChart.canvas.parentNode.style.height = '400px';
  radarChart.canvas.parentNode.style.margin = '0';
}
